import { CalendarToday as CalendarIcon, Chat as ChatIcon, CheckCircle as CheckCircleIcon, Flag as PriorityIcon, Assignment as TodoIcon } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React from "react";

export const OnboardingComplete: React.FC = () => {
  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 800,
        mx: "auto",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box textAlign="center">
        <Avatar
          sx={{
            width: 80,
            height: 80,
            mx: "auto",
            mb: 3,
            bgcolor: "success.main",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 40 }} />
        </Avatar>

        <Typography variant="h4" component="h2" gutterBottom fontWeight="bold">
          Welcome to Costaff.ai!
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500, mx: "auto" }}>
          Costaff.ai is now connected and ready to help you manage your tasks, schedule, and priorities. Let&apos;s get started!
        </Typography>

        <Card sx={{ mb: 4, textAlign: "left" }}>
          <CardContent>
            <Typography variant="h6" component="h3" gutterBottom fontWeight="medium">
              What You Can Do Now:
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                    <ChatIcon sx={{ fontSize: 18 }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText primary="Chat to your New Assistant" secondary="Get help with tasks, scheduling, and planning" />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                    <CalendarIcon sx={{ fontSize: 18 }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText primary="Manage your Calendar" secondary="View and manage your Google Calendar integration" />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                    <TodoIcon sx={{ fontSize: 18 }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText primary="Manage Todo" secondary="Create and track your tasks and to-dos" />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.main" }}>
                    <PriorityIcon sx={{ fontSize: 18 }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText primary="Manage Priorities" secondary="Set and organize your goals and priorities" />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};
